import { useState, useEffect } from 'react';
import { Button, Drawer } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import { Link, useLocation } from 'react-router-dom'; // Import useLocation
import Logo from '../images/visionapostolica_logo.webp';
import '../styles/Navbar.css';

const Navbar = ({ selected, setSelected }) => {
  const location = useLocation(); // Get the current route

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const showDrawer = () => setIsDrawerOpen(true);
  const closeDrawer = () => setIsDrawerOpen(false);

  // Update the selected state based on the current route
  useEffect(() => {
    switch (location.pathname) {
      case '/':
        setSelected('Inicio');
        break;
      case '/nuestra_fe':
        setSelected('Nuestra Fé');
        break;
      case '/kids':
        setSelected('Kids');
        break;
      case '/material_lectura':
        setSelected('MaterialLectura');
        break;
      default:
        setSelected('');
    }
  }, [location.pathname, setSelected]); // Run this effect whenever the route changes

  return (
    <div className="navbar">
      <div className="navbar-logo">
        <Link to="/" onClick={() => setSelected('Inicio')}>
          <img src={Logo} alt="logo" />
        </Link>
      </div>

      {/* Desktop Links */}
      <div className="navbar-links">
        <Link to="/" onClick={() => setSelected('Inicio')}>
          <Button type={selected === 'Inicio' ? 'link' : 'text'}>Inicio</Button>
        </Link>
        <Link to="/nuestra_fe" onClick={() => setSelected('Nuestra Fé')}>
          <Button type={selected === 'Nuestra Fé' ? 'link' : 'text'}>
            Nuestra Fe
          </Button>
        </Link>
        <Link to="/kids" onClick={() => setSelected('Kids')}>
          <Button type={selected === 'Kids' ? 'link' : 'text'}>Kids</Button>
        </Link>
        <Link
          to="/material_lectura"
          onClick={() => setSelected('MaterialLectura')}
        >
          <Button type={selected === 'MaterialLectura' ? 'link' : 'text'}>
            Audios de cultos
          </Button>
        </Link>
      </div>

      {/* Mobile Drawer */}
      <div className="navbar-hamburger">
        <Button type="text" icon={<MenuOutlined />} onClick={showDrawer} />
      </div>
      <Drawer
        title="Menu"
        placement="right"
        onClose={closeDrawer}
        open={isDrawerOpen}
      >
        <Link
          to="/"
          onClick={() => {
            setSelected('Inicio');
            closeDrawer();
          }}
        >
          <Button type={selected === 'Inicio' ? 'link' : 'text'}>Inicio</Button>
        </Link>
        <Link
          to="/nuestra_fe"
          onClick={() => {
            setSelected('Nuestra Fé');
            closeDrawer();
          }}
        >
          <Button type={selected === 'Nuestra Fé' ? 'link' : 'text'}>
            Nuestra Fe
          </Button>
        </Link>
        <Link
          to="/kids"
          onClick={() => {
            setSelected('Kids');
            closeDrawer();
          }}
        >
          <Button type={selected === 'Kids' ? 'link' : 'text'}>Kids</Button>
        </Link>
        <Link
          to="/material_lectura"
          onClick={() => {
            setSelected('MaterialLectura');
            closeDrawer();
          }}
        >
          <Button type={selected === 'MaterialLectura' ? 'link' : 'text'}>
            Audios de cultos
          </Button>
        </Link>
      </Drawer>
    </div>
  );
};

export default Navbar;
